<template>
	<div class="notice-wrapper">
		<div class="notice-card">
			<div class="header-band">
				<h1>📢 重要通知</h1>
			</div>
			<div class="content">
				<div class="notice-body">
					<div class="greeting">尊敬的各位学员：</div>
					<div class="message">
						因平台升级调整，<strong>本平台不再提供学习服务</strong>。为确保您能继续完成继续教育学习任务，请您及时访问新学习平台进行课程学习。
					</div>

					<div class="link-area">
						<div class="link-label">
							<span class="icon-em">🔗</span> 新学习平台入口：
						</div>
						<div class="url-box">
							<span class="url-text">{{ platformUrl }}</span>
							<div style="display: flex; gap: 10px; flex-wrap: wrap">
								<button class="copy-btn" @click="copyLink">📋 复制链接</button>
								<button class="visit-btn" @click="openLink">🌐 访问网站</button>
							</div>
						</div>
						<div style="margin-top: 12px; font-size: 0.85rem; color: #4f6f8f">
							⚡ 请选择 <strong>“甘肃建投继续教育模块”</strong> 进行学习
						</div>
					</div>

					<a :href="platformUrl" target="_blank" rel="noopener noreferrer" class="big-link-button">
						立即前往学习平台 →
					</a>

					<div class="apology">
						<span>🕊️</span> 由此给您带来的不便，敬请谅解！ <span>🙏</span>
					</div>
				</div>
			</div>
			<div class="footer-note">｜ 甘肃建投继续教育 · 官方指定学习入口 ｜</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "NoticePage",
		data() {
			return {
				platformUrl: "https://gjex.gsjtpxzx.com",
			};
		},
		methods: {
			// 复制链接
			async copyLink() {
				const url = this.platformUrl;
				try {
					await navigator.clipboard.writeText(url);
					this.showTemporaryMessage("copyBtn", "✅ 已复制！");
				} catch (err) {
					// 降级方案
					const textarea = document.createElement("textarea");
					textarea.value = url;
					document.body.appendChild(textarea);
					textarea.select();
					document.execCommand("copy");
					document.body.removeChild(textarea);
					this.showTemporaryMessage("copyBtn", "📋 复制成功");
				}
			},
			// 打开链接
			openLink() {
				window.open(this.platformUrl, "_blank", "noopener,noreferrer");
			},
			// 辅助方法：临时修改按钮文字并恢复
			showTemporaryMessage(btnRef, message) {
				// 由于按钮没有ref，直接通过类名或手动查询来反馈更稳妥（但为了体验简单）
				// 获取复制按钮元素
				const copyButton = document.querySelector(".copy-btn");
				if (copyButton) {
					const originalText = copyButton.innerHTML;
					copyButton.innerHTML = message;
					setTimeout(() => {
						copyButton.innerHTML = originalText;
					}, 1500);
				}
			},
		},
	};
</script>

<style scoped>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	.notice-wrapper {
		font-family: "Segoe UI", "Roboto", "Noto Sans", system-ui, -apple-system,
			"Helvetica Neue", sans-serif;
		background: linear-gradient(145deg, #e9f0f5 0%, #d9e2ec 100%);
		min-height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 2rem 1.5rem;
	}

	/* 主卡片容器 */
	.notice-card {
		max-width: 780px;
		width: 100%;
		background: #ffffff;
		border-radius: 2rem;
		box-shadow: 0 25px 45px -12px rgba(0, 0, 0, 0.25), 0 8px 18px rgba(0, 0, 0, 0.05);
		overflow: hidden;
		transition: transform 0.2s ease, box-shadow 0.2s ease;
	}

	.notice-card:hover {
		transform: translateY(-4px);
		box-shadow: 0 30px 50px -15px rgba(0, 0, 0, 0.3);
	}

	/* 头部醒目色带 */
	.header-band {
		background: #b22234;
		padding: 1rem 2rem;
		text-align: center;
	}

	.header-band h1 {
		color: white;
		font-size: 1.8rem;
		font-weight: 700;
		letter-spacing: 2px;
		word-break: keep-all;
		text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
	}

	/* 内容区域 */
	.content {
		padding: 2.2rem 2rem 2.5rem 2rem;
	}

	/* 通知主体 */
	.notice-body {
		margin-bottom: 2rem;
	}

	.greeting {
		font-size: 1.3rem;
		font-weight: 600;
		color: #1e2a3e;
		margin-bottom: 1rem;
		border-left: 5px solid #b22234;
		padding-left: 1rem;
	}

	.message {
		font-size: 1.05rem;
		line-height: 1.55;
		color: #2c3e4f;
		margin-bottom: 1.5rem;
		background: #f8fafc;
		padding: 1.2rem 1.5rem;
		border-radius: 1.2rem;
		border: 1px solid #e2edf2;
	}

	.link-area {
		background: #f0f6fa;
		border-radius: 1.2rem;
		padding: 1.4rem 1.5rem;
		margin: 1.8rem 0 1.2rem 0;
		border: 1px solid #cbdde6;
		transition: all 0.2s;
	}

	.link-label {
		font-weight: 600;
		color: #0f3b4f;
		margin-bottom: 0.8rem;
		display: flex;
		align-items: center;
		gap: 0.5rem;
		font-size: 1rem;
	}

	.url-box {
		background: white;
		border-radius: 1rem;
		padding: 0.8rem 1rem;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		gap: 1rem;
		border: 1px solid #cbdde6;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
	}

	.url-text {
		font-family: "SF Mono", "Fira Code", monospace;
		font-size: 0.9rem;
		color: #1e4663;
		word-break: break-all;
		background: #fef9e6;
		padding: 0.3rem 0.7rem;
		border-radius: 0.8rem;
		flex: 1;
		text-decoration: none;
		font-weight: 500;
	}

	.copy-btn,
	.visit-btn {
		background: #ffffff;
		border: 1px solid #b0c4d9;
		padding: 0.5rem 1rem;
		border-radius: 2rem;
		font-size: 0.85rem;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.2s;
		color: #1e4663;
		display: inline-flex;
		align-items: center;
		gap: 6px;
		background: #f9fbfd;
	}

	.copy-btn:hover,
	.visit-btn:hover {
		background: #e6f0f7;
		border-color: #7f9eb5;
		transform: scale(0.97);
	}

	.copy-btn:active,
	.visit-btn:active {
		background: #cddfea;
	}

	.big-link-button {
		display: inline-block;
		margin-top: 0.8rem;
		width: 100%;
		text-align: center;
		background: #b22234;
		color: white;
		text-decoration: none;
		padding: 0.9rem 1.2rem;
		border-radius: 3rem;
		font-weight: 600;
		font-size: 1.05rem;
		transition: background 0.2s, transform 0.1s;
		box-shadow: 0 6px 14px rgba(178, 34, 52, 0.25);
		letter-spacing: 1px;
	}

	.big-link-button:hover {
		background: #8b1a2a;
		transform: scale(1.01);
		box-shadow: 0 8px 18px rgba(139, 26, 42, 0.3);
	}

	.apology {
		margin-top: 2rem;
		padding-top: 1rem;
		border-top: 1px dashed #cbdde6;
		font-size: 0.9rem;
		color: #4a627a;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0.4rem;
		flex-wrap: wrap;
	}

	.footer-note {
		background: #f9fafc;
		padding: 0.9rem 2rem;
		text-align: center;
		font-size: 0.75rem;
		color: #5f7f9c;
		border-top: 1px solid #e2edf2;
	}

	.icon-em {
		font-size: 1.1rem;
	}

	@media (max-width: 550px) {
		.content {
			padding: 1.5rem;
		}

		.header-band h1 {
			font-size: 1.4rem;
		}

		.greeting {
			font-size: 1.2rem;
		}

		.url-box {
			flex-direction: column;
			align-items: stretch;
		}

		.copy-btn,
		.visit-btn {
			justify-content: center;
		}

		.big-link-button {
			padding: 0.75rem 1rem;
			font-size: 0.95rem;
		}
	}
</style>